// Search and AI crawlers render the page like a browser, which used to fire every tracking
// call and count Googlebot as a visitor. Crawlers are recognised by their user agent and
// the bookkeeping is skipped for them — the content they came for is untouched.
const BOT = /bot|crawl|spider|slurp|googlebot|google-inspectiontool|bingpreview|facebookexternalhit|headless|lighthouse|gptbot|claude|perplexity|bytespider|petalbot|yandex|baidu|duckduck/i;

export const isBot = typeof navigator !== 'undefined' && BOT.test(navigator.userAgent || '');